import React from 'react';
import Card from '../../Shared/Cards/BlogCard/Card';
import { cards2 } from './data';
import './Styles/Cards.scss';

const Cards2=()=>{
    return(
        <div className="blog-cards bcards2">
            {cards2.map((d,i) =>{
                return(
                    <Card 
                    key={i} {...d}
                    />
                )
            })}
        </div>
    )
};
export default Cards2 ;